import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    RestoreSalesDocument as RestoreSalesDocumentMutation,
    RestoreSalesDocumentVariables,
    SalesDocumentRestoreInput,
} from 'nutshell-graphql-types';

import RESTORE_SALES_DOCUMENT from '../mutations/restore-sales-document.graphql';

export const useRestoreSalesDocument = (): {
    restoreSalesDocument: (arg1: SalesDocumentRestoreInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [restoreSalesDocument, {loading, error}] = useMutation<
        RestoreSalesDocumentMutation,
        RestoreSalesDocumentVariables
    >(RESTORE_SALES_DOCUMENT);

    return {
        restoreSalesDocument: (input: SalesDocumentRestoreInput) =>
            restoreSalesDocument({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
